/* global axios */
import ApiClient from './ApiClient';

const getTimeOffset = () => -new Date().getTimezoneOffset() / 60;

class AnalyticsReportsAPI extends ApiClient {
  constructor() {
    super('analytics_reports', { accountScoped: true, apiVersion: 'v2' });
  }

  getAnalytics({ from, to, businessHours, page = 1, assigneeId }) {
    return axios.get(this.url, {
      params: {
        since: from,
        until: to,
        business_hours: businessHours,
        timezone_offset: getTimeOffset(),
        page,
        assignee_id: assigneeId || undefined,
      },
    });
  }
}

export default new AnalyticsReportsAPI();
